export class Person {
    name: string;
    email: string;

    constructor(theName: string, theEmail: string) {
        this.name = theName;
        this.email = theEmail;
    }
}